export var dotsStyles = [
	{

		thumb: "",
		data: {
			"paginationWrap": { "options": { "type": "", "tag": "", "class": "" }, "styles": { "display": { "Desktop": "flex" }, "justifyContent": { "Desktop": "center" }, "paddingTop": { "Desktop": "30px" } } },
			"paginationItem": { "options": { "tag": "", "class": "" }, "styles": { "backgroundColor": { "Desktop": "#f1f7f9" }, "width": { "Desktop": "15px" }, "height": { "Desktop": "15px" }, "margin": { "Desktop": "0px 10px 0px 0px" }, "borderRadius": { "Desktop": " 20px 20px 20px 20px" }, "border": { "Desktop": "1px solid #1f2937" } } },
			"paginationItemActive": { "options": { "class": "" }, "styles": { "backgroundColor": { "Desktop": "#1f2e45" } } },

		}
	},
	{

		thumb: "",
		data: {
			"paginationWrap": { "options": { "type": "", "tag": "", "class": "" }, "styles": { "display": { "Desktop": "flex" }, "justifyContent": { "Desktop": "center" }, "paddingTop": { "Desktop": "30px" } } },
			"paginationItem": { "options": { "tag": "", "class": "" }, "styles": { "backgroundColor": { "Desktop": "#7958ff" }, "margin": { "Desktop": "0px 10px 0px 0px" }, "borderRadius": { "Desktop": "6px 6px 6px 6px" }, "border": { "Desktop": "0px solid #201556" }, "padding": { "Desktop": "10px 10px 10px 10px" }, "transform": { "Desktop": "rotate(-45deg) " } } },
			"paginationItemActive": { "options": { "class": "" }, "styles": { "backgroundColor": { "Desktop": "#1f2e45" } } },

		}
	},

	{

		thumb: "",
		data: {
			"paginationWrap": { "options": { "type": "", "tag": "", "class": "" }, "styles": { "display": { "Desktop": "flex" }, "justifyContent": { "Desktop": "center" }, "paddingTop": { "Desktop": "30px" } } },
			"paginationItem": { "options": { "tag": "", "class": "" }, "styles": { "backgroundColor": { "Desktop": "#7958ff" }, "margin": { "Desktop": "0px 10px 0px 0px" }, "borderRadius": { "Desktop": "6px 6px 6px 6px" }, "border": { "Desktop": "2px solid #201556" }, "padding": { "Desktop": "10px 10px 10px 10px" }, "transform": { "Desktop": "rotate(-45deg) " } } },
			"paginationItemActive": { "options": { "class": "" }, "styles": { "backgroundColor": { "Desktop": "#1f2e45" } } },

		}
	},
];

